import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { set } from "lodash";
import { ListNetworkData } from "../../utils/list/objects/listNetworkData";
import { ListPeriodFilterShortcut } from "../../utils/list/objects/listPeriodFilterShortcut";
import { EditNewsletterContactsGroup } from "../objects/editNewsletterContactsGroup";
import { NewsletterContactsGroupInput } from "../objects/newsletterContactsGroupInput";
import { NewsletterContactsGroupsState } from "../objects/newsletterContactsGroupsState";

const initialState: NewsletterContactsGroupsState = {
    allContacts: {state: 'loading'},
    createContactsGroupForm: {
        name: '',
        contacts: []
    },
    editGroup: {
        state: 'loading'
    },
    editGroupForm: {
        name: '',
        contacts: []
    },
    openedEditForm: null,
    listData: {
        state: 'loading'
    },
    listFilters: {
        period: {
            type: 'CREATION',
            shortcut: ListPeriodFilterShortcut.NONE,
            values: {
                CREATION: {
                    LESS_THAN: new Date().toISOString(),
                    GREATER_THAN: new Date().toISOString(),
                },
                MODIFICATION: {
                    LESS_THAN: new Date().toISOString(),
                    GREATER_THAN: new Date().toISOString(),
                },
            }
        },
    },
};

const slice = createSlice({
    name: 'newsletterContactsGroups',
    initialState: initialState,
    reducers: {
        setAllContacts: (
            state,
            action: PayloadAction<NewsletterContactsGroupsState['allContacts']>
        ): void => {
            state.allContacts = action.payload;
        },
        setEditGroup: (
            state,
            action: PayloadAction<EditNewsletterContactsGroup>
        ): void => {
            state.editGroup = action.payload;
        },
        setEditGroupForm: (
            state,
            action: PayloadAction<NewsletterContactsGroupInput>
        ): void => {
            state.editGroupForm = action.payload;
        },
        setEditGroupFormValue<K extends keyof NewsletterContactsGroupInput>(
            state: NewsletterContactsGroupsState,
            action: PayloadAction<{
                key: K
                value: NewsletterContactsGroupInput[K]
            }>
        ): void {
            state.editGroupForm[action.payload.key] = action.payload.value;
        },
        setListData: (
            state,
            action: PayloadAction<ListNetworkData>
        ): void => {
            state.listData = action.payload;
        },
        setCreateContactsGroupFormValue: (
            state,
            action: PayloadAction<{
                key: string,
                value: any
            }>
        ): void => {
            set(state.createContactsGroupForm, action.payload.key, action.payload.value);
        },
        setListFiltersValue: (
            state,
            action: PayloadAction<{
                key: string,
                value: any
            }>
        ): void => {
            set(state.listFilters, action.payload.key, action.payload.value);
        },
        setOpenedEditForm: (
            state,
            action: PayloadAction<NewsletterContactsGroupsState['openedEditForm']>
        ): void => {
            state.openedEditForm = action.payload;
        }
    }
});

export const {
    setAllContacts,
    setEditGroupForm,
    setEditGroup,
    setEditGroupFormValue,
    setCreateContactsGroupFormValue,
    setListData,
    setListFiltersValue,
    setOpenedEditForm,
} = slice.actions;

export default slice;